import i18n from '@/i18n';
import { getProductMeta, hydrateProductMetaFromItemRaw } from './platformListingProductMeta';
import { listingStatusLabel, resolveListingStatus } from './syncListingProductMetaFromJobs';

function firstText(...values) {
  for (const value of values) {
    const text = String(value || '').trim();
    if (text) return text;
  }
  return '';
}

export function listingRiskStatusClass(risk, assessing = false) {
  if (assessing) return 'processing';
  if (risk === 'high') return 'failed';
  if (risk === 'medium') return 'partial';
  if (risk === 'low') return 'success';
  if (risk === 'unknown') return 'success';
  return 'waiting';
}

export function listingRiskLabel(risk, assessing = false) {
  if (assessing) return i18n.t('workbench:studioChrome.assessing');
  if (risk === 'high') return i18n.t('workbench:studioChrome.riskHigh');
  if (risk === 'medium') return i18n.t('workbench:studioChrome.riskMedium');
  if (risk === 'low') return i18n.t('workbench:studioChrome.riskLow');
  return i18n.t('workbench:studioChrome.riskPending');
}

export function listingStatusToneClass(status) {
  if (status === 'listed') return 'success';
  if (status === 'listing') return 'processing';
  if (status === 'failed') return 'failed';
  return 'waiting';
}

function shopNameFromList(shops, shopId) {
  const id = String(shopId || '').trim();
  if (!id) return '';
  const shop = (Array.isArray(shops) ? shops : []).find((row) => String(row?.id) === id);
  return firstText(shop?.shopName, shop?.name);
}

/**
 * 商品库详情表：刊登状态 / 侵权风险 / 刊登信息（店铺、类目、产品模板、状态）。
 * @param {object} item
 * @param {object[]} [shops]
 */
export function resolveListingGalleryMeta(item, shops = []) {
  hydrateProductMetaFromItemRaw(item);
  const meta = item?.id != null ? getProductMeta(item.id) : {};
  const raw = item?.raw && typeof item.raw === 'object' ? item.raw : {};
  const rawRisk = String(raw?.risk || '').trim().toLowerCase();
  const effectiveRisk = (meta.risk && meta.risk !== 'pending')
    ? meta.risk
    : (rawRisk && rawRisk !== 'pending' ? rawRisk : meta.risk);
  const rawAdvice = String(raw?.riskAdvice || '').trim();
  const rawElements = Array.isArray(raw?.riskElements)
    ? raw.riskElements.map((el) => String(el || '').trim()).filter(Boolean)
    : [];
  const effectiveAdvice = meta.riskAdvice
    || rawAdvice
    || (rawElements.length ? rawElements.join('、') : '');
  const status = resolveListingStatus(item, meta);
  const shopId = firstText(item?.targetShopId, meta.listingShopId);
  const hasRiskResult = Boolean(effectiveAdvice)
    || (effectiveRisk && effectiveRisk !== 'pending' && !meta.assessing);
  return {
    meta: {
      ...meta,
      risk: effectiveRisk,
      riskAdvice: effectiveAdvice,
      assessing: meta.assessing,
    },
    status,
    statusLabel: listingStatusLabel(status),
    statusClass: listingStatusToneClass(status),
    riskLabel: listingRiskLabel(effectiveRisk, meta.assessing),
    riskClass: listingRiskStatusClass(effectiveRisk, meta.assessing),
    shopName: firstText(meta.listingShopName, shopNameFromList(shops, shopId)),
    categoryLabel: firstText(meta.listingCategoryPathLabel, item?.listingCategoryPathLabel),
    templateName: firstText(meta.listingProductTemplateName, item?.listingProductTemplateName),
    canOpenListing: status === 'listed' || status === 'failed',
    canOpenRisk: hasRiskResult,
  };
}
